import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { OnboardedUser } from '@core/services/api/api.service';

@Injectable({ providedIn: 'root' })
export class UserEventsService {
  // Replay the most recent created user to late subscribers
  private readonly createdSubject = new ReplaySubject<OnboardedUser>(1);
  public readonly created$: Observable<OnboardedUser> = this.createdSubject.asObservable();

  emitCreated(user: OnboardedUser): void {
    if (!user) return;
    this.createdSubject.next(user);
  }
}
